import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { LoadingModule } from '@components/loading';
import { CsIconModule } from '@components/icon';
import { authenticationGuard } from '../guards/authentication.guard';
import { onboardingGuard } from '../guards/onboarding.guard';
import { OutgoingCallFeedbackComponent } from './outgoing-call-feedback.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule.forChild([{
      path: 'outgoing-call-feedback-form',
      canActivate: [authenticationGuard, onboardingGuard],
      component: OutgoingCallFeedbackComponent,
      data: { openedPage: { pageName: 'OutgoingCallFeedbackPage' } },
    }]),
    LoadingModule,
    CsIconModule,
  ],
  declarations: [OutgoingCallFeedbackComponent],
})
export class OutgoingCallFeedbackModule {}
